<template>
  <v-overlay
    :model-value="isLoading"
    absolute
    class="d-flex align-center justify-center"
  >
    <font-awesome-icon
      :icon="['fas', 'spinner']"
      spin
      size="2x"
    />
  </v-overlay>
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
